import React, { useState, useContext, useEffect } from 'react'
import IStatistics from './statistics.interface'
import StatisticsContext from './statistics-context'
import DashboardContext from '../layout/dashboard-context'
import api from '../../api'
import StatisticsInfo from './statistics-info'

interface StatisticsStartPageProps {
  setStep: (step: number) => void
}

const StatisticsStartPage: React.FC<StatisticsStartPageProps & IStatistics> = ({
  setStep,
}: StatisticsStartPageProps & IStatistics) => {
  const { selectedOrganization } = useContext(DashboardContext)
  const { setReceived } = useContext(StatisticsContext)
  const [alreadySentStatistics, setAlreadySentStatistics] = useState<boolean>(false)
  const [shouldNotSendStatistics, setShouldNotSendStatistics] = useState<boolean>(false)

  const getAccountData = async () => {
    if (selectedOrganization) {
      try {
        const res = await api.get(`/accounts/${selectedOrganization.id}/statistics`)
        const data = res.data

        setReceived({
          data: [],
          imported: false,
        })

        setAlreadySentStatistics(data.data.has_left_statsticas_year_c)
        setShouldNotSendStatistics(data.data.statistics === 'not_submit_statistics')
      } catch (e) {
        console.log({ e })
      }
    }
  }

  useEffect(() => {
    getAccountData()
  }, [])

  const nextStep = () => {
    setStep(2)
  }

  return (
    <div className="card flex flex-col w-full bg-white gap-8">
      <StatisticsInfo
        alreadySentStatistics={alreadySentStatistics}
        showStatus={true}
        showOrganization={false}
      />

      <div className="flex md:flex-row flex-col justify-start items-center w-full card-border-grey  flex-wrap  gap-4 md:gap-0">
        <div className="statistics-img">
          <img src="/statistics-step-1.svg" alt="Läs anvisningar" />
          <span className="font-bold text-darkBlue text-center">Läs anvisningar</span>
        </div>
        <svg
          className="statistics-img md:block hidden"
          xmlns="http://www.w3.org/2000/svg"
          width="65"
          height="10"
          viewBox="0 0 72 10"
          fill="none"
        >
          <path d="M0.420898 4.79492H71.2104" stroke="#003D64" stroke-width="8.74436" />
        </svg>
        <div className="statistics-img">
          <img src="/statistics-step-2.svg" alt="Ladda ner mall" />
          <span className="font-bold text-darkBlue text-center">Ladda ner mall</span>
        </div>
        <svg
          className="statistics-img md:block hidden"
          xmlns="http://www.w3.org/2000/svg"
          width="65"
          height="10"
          viewBox="0 0 72 10"
          fill="none"
        >
          <path d="M0.420898 4.79492H71.2104" stroke="#003D64" stroke-width="8.74436" />
        </svg>
        <div className="statistics-img">
          <img src="/statistics-step-3.svg" alt="Ladda upp ifylld mall" />{' '}
          <span className="font-bold text-darkBlue text-center">Ladda upp ifylld mall</span>
        </div>
        <svg
          className="statistics-img md:block hidden"
          xmlns="http://www.w3.org/2000/svg"
          width="65"
          height="10"
          viewBox="0 0 72 10"
          fill="none"
        >
          <path d="M0.420898 4.79492H71.2104" stroke="#003D64" stroke-width="8.74436" />
        </svg>
        <div className="statistics-img">
          <img src="/statistics-step-4.svg" alt="Kontroller och korrigeringar" />
          <span className="font-bold text-darkBlue text-center">Kontroller och korrigeringar</span>
        </div>
        <svg
          className="statistics-img md:block hidden"
          xmlns="http://www.w3.org/2000/svg"
          width="65"
          height="10"
          viewBox="0 0 72 10"
          fill="none"
        >
          <path d="M0.420898 4.79492H71.2104" stroke="#003D64" stroke-width="8.74436" />
        </svg>

        <div className="statistics-img">
          <img src="/statistics-step-5.svg" alt="Klar" />
          <span className="font-bold text-darkBlue text-center">Klar!</span>
        </div>
      </div>

      <div className="flex flex-col  md:flex-row justify-between items-center w-full pt-8 gap-4">
        <div className="w-full">
          <p>
            Vid frågor, maila{' '}
            <a
              href="mailto:statistik@fastigo.se"
              className="text-darkBlue underline font-bold "
              target="_blank"
            >
              statistik@fastigo.se
            </a>{' '}
          </p>
          <p>
            eller ring på{' '}
            <a href="tel:086766923" className="text-darkBlue underline font-bold " target="_blank">
              08-676 69 23
            </a>{' '}
          </p>
        </div>
        <div className="w-full flex justify-end">
          <button
            className="btn btn-long"
            onClick={() => nextStep()}
            disabled={shouldNotSendStatistics || alreadySentStatistics}
          >
            Lämna in statistik
          </button>
        </div>
      </div>
    </div>
  )
}

export default StatisticsStartPage
